import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    EachWayTermsList,
    EachWayTermsListElement,
} from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/EachWayTerms.style';

interface EachWayTermsPropsType {
    eachWayTerms: {
        places: number;
        reduction: {
            den: number;
            num: number;
        };
    };
    numDenVal: string;
}

export const EachWayTerms = observer('EachWayTerms', ({ eachWayTerms, numDenVal }: EachWayTermsPropsType) => {
    return (
        <EachWayTermsList>
            <EachWayTermsListElement data-test='ew-terms'>
                <I18n
                    langKey='bets.selection.each-way-terms.label'
                    defaultText='EW Terms'
                />
            </EachWayTermsListElement>

            <EachWayTermsListElement data-test='ew-reduction'>{numDenVal}</EachWayTermsListElement>

            <EachWayTermsListElement data-test='ew-places'>
                <I18n
                    langKey='bets.selection.each-way-terms.places'
                    defaultText='{places} Places'
                    params={{ places: eachWayTerms.places }}
                />
            </EachWayTermsListElement>
        </EachWayTermsList>
    );
});
